export type Theme = 'light' | 'dark';

const KEY = 'hub-theme';

/** Výchozí je světlý vzhled; volba se pamatuje v prohlížeči. */
export function currentTheme(): Theme {
  try {
    return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* soukromé okno — volba platí jen do obnovení stránky */
  }
}
